import React from "react"

import ImageSelector from "../../../common/ImageSelector"

const SourceEditItemDetails = ({
    name,
    url,
    description,
    active,
    favicon,
    imagePreviewURL,
    onEventChange,
    onImageChange
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />Name
            </h3>
            <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Name"
                value={name}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-article" />URL
            </h3>
            <input
                type="text"
                name="url"
                className="form-control"
                placeholder="URL"
                value={url}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-headline" />Description
            </h3>
            <textarea
                name="description"
                className="form-control"
                placeholder="Description"
                value={description}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-article" />Status
            </h3>
            <label>
                <input
                    type="checkbox"
                    name="active"
                    checked={active}
                    onChange={onEventChange}
                />{" "}
                Active
            </label>
            <h3>
                <i className="icon icon-heroimg" />Logo
            </h3>
            <ImageSelector
                onImageSelect={onImageChange}
                imageUrl={
                    imagePreviewURL !== undefined ? imagePreviewURL : favicon
                }
            />
        </div>
    </div>
)

export default SourceEditItemDetails
